import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainSection() {
  const pains = ['Salís a correr y siempre terminás con el mismo tiempo — frustración silenciosa que te carcome', 'Te duele la rodilla, la tibia o la cadera cada tanto — miedo a que un día el dolor sea definitivo', 'Seguís un plan de internet y no te funciona — sensación de que algo está mal en vos', 'Ves a otros progresar y no entendés por qué ellos sí — comparación que destruye la motivación', 'Entrenás mucho pero tu cuerpo no cambia — cansancio de esforzarte sin recompensa', 'No sabés si estás entrenando bien o mal — confusión constante que paraliza'];
  return <section className="py-8 md:py-16 px-4 max-w-4xl mx-auto" data-id="element-240">
      <FadeIn data-id="element-241">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-3 md:mb-6 px-2 text-[#0f172a]" data-id="element-242">
          ¿Te suena familiar alguna de estas situaciones?
        </h2>

        <div className="text-sm md:text-xl text-[#475569] text-center mb-5 md:mb-12 space-y-2.5 md:space-y-4 max-w-3xl mx-auto font-medium" data-id="element-243">
          <p data-id="element-244">
            El 90% de los runners entrena sin ningún tipo de sistema. Sale,
            corre, vuelve. Y espera que los resultados lleguen solos.
          </p>
          <p className="font-bold text-[#0f172a] text-lg md:text-2xl mt-4 md:mt-8" data-id="element-245">
            El progreso no es consecuencia del esfuerzo.{' '}
            <span className="text-[#ef4444]" data-id="element-246">
              Es consecuencia del esfuerzo bien dirigido.
            </span>
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-16" data-id="element-247">
        {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-248">
            <motion.div whileHover={{
          scale: 1.02,
          backgroundColor: '#f8fafc'
        }} className="bg-white border border-[#e2e8f0] rounded-2xl p-4 md:p-6 flex gap-3 md:gap-4 items-start h-full transition-colors shadow-sm" data-id="element-249">
              <XCircle className="text-[#ef4444] shrink-0 mt-0.5 w-5 h-5 md:w-6 md:h-6" data-id="element-250" />
              <span className="text-sm md:text-lg text-[#0f172a] leading-relaxed font-medium" data-id="element-251">
                {pain}
              </span>
            </motion.div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-252">
        <div className="text-center relative" data-id="element-253">
          <div className="absolute inset-0 bg-[#22c55e]/10 blur-3xl rounded-full" data-id="element-254"></div>
          <motion.div animate={{
          y: [0, -5, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative z-10 inline-flex flex-col items-center" data-id="element-255">
            <Sparkles className="text-[#22c55e] mb-2 md:mb-4 w-6 h-6 md:w-8 md:h-8" data-id="element-256" />
            <h3 className="text-2xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#16a34a] via-[#22c55e] to-[#4ade80] drop-shadow-sm px-2" data-id="element-257">
              Eso termina hoy.
            </h3>
          </motion.div>
        </div>
      </FadeIn>
    </section>;
}